// src/shared/lib/sentry.ts

import * as Sentry from '@sentry/react';

export function initSentry() {
  const isLocalhost = window.location.hostname === 'localhost';
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
  const baseApiUrl = import.meta.env.VITE_API_BASE_URL;
  let traceTargetRegex: RegExp | null = null;

  if (!sentryDsn || isLocalhost) return;

  try {
    const apiUrl = new URL(baseApiUrl);
    traceTargetRegex = new RegExp(
      `${apiUrl.host}${apiUrl.pathname}`.replace(/\//g, '\\/'),
    );
  } catch (err) {
    console.warn(
      'Invalid VITE_API_BASE_URL format for Sentry tracing:',
      baseApiUrl,
    );
  }

  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:/,
      ...(traceTargetRegex ? [traceTargetRegex] : []),
    ],
  });
}

export function setSentryUser(user?: {
  id: string;
  email?: string;
  name?: string;
}) {
  if (!user) return;
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
  });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
